import { createElement } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

const SvgReplaceIcon = (props: SvgIconProps) =>
  createElement(
    SvgIcon,
    props,
    <path
      clipRule="evenodd"
      d="m4.533 8.4 5.59-5.867L11.29 3.76 7.703 7.524h11.764v1.752H7.703l3.588 3.764-1.168 1.227zm14.934 8.533-5.59 5.867-1.168-1.226 3.588-3.765H4.533v-1.751h11.764l-3.588-3.765 1.168-1.226z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  )
export default SvgReplaceIcon
